import { ILegalEntityLookup } from 'APIPackage/FnsModule/interfaces/ILegalEntityLookup';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';

export const generateLegalEntityLookupText = (legalEntityLookup: ILegalEntityLookup): string => {
  const textArray: string[] = [];

  if (legalEntityLookup.inn) {
    textArray.push(`ИНН: ${legalEntityLookup.inn}`);
  }
  if (legalEntityLookup.ogrn) {
    textArray.push(`ОГРН: ${legalEntityLookup.ogrn}`);
  }
  if (legalEntityLookup.orgName) {
    textArray.push(`Наименование: ${legalEntityLookup.orgName}`);
  }
  if (legalEntityLookup.dateReg) {
    textArray.push(
      `Дата регистрации: ${formatDate({
        date: legalEntityLookup.dateReg.split('.').reverse().join('.'),
        dateFormat: DATE_FORMAT_LONG_FNS,
      })}`,
    );
  }
  if (legalEntityLookup.leAddress) {
    textArray.push(`Адрес местонахождения: ${legalEntityLookup.leAddress}`);
  }

  return textArray.join(', ');
};
